import { render } from "./ShowcaseLayout.vue?vue&type=template&id=36fbea2c&ts=true"
import script from "./ShowcaseLayout.vue?vue&type=script&lang=ts"
export * from "./ShowcaseLayout.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__